/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Skeleton from "./Skeleton";

const TimeSlotsSkeleton = ({ count = 4 }) => {
  return [...Array(count)].map((_, index) => <Skeleton key={index} borderRadius={50} width="100%" height="2.625rem" />);
};

export default TimeSlotsSkeleton;
